<template>
  <div>
    <h2>Выписка</h2>
    <div style="margin-bottom:20px;">  
      <input style="margin: 0 10px 0 10px;"
              type="password"
              placeholder="введите пароль"
              id="name"
              v-model="passw"
            />
      </div>
      <div>
        <button @click="getPrivat">сформировать выписку</button>
      </div>
    <div style="margin-top:30px;">
      
      <label>дата нач <input type="date"  v-model="startDate"></label>
      </div>
      <div  style="margin-top:5px;">
<label>дата кон <input type="date"  v-model="endDate"></label>
      </div>
      
    
    <div style="margin-top:10px;">
    <button @click="getPrivatData">сформировать выписку по датам</button>  
    </div> 
    
    
    

    <div v-if="privatData !=''">

      <ul style="text-align:left;">
        <li v-for="item in privatData" :key="item.ID">
          <span v-if="item.TRANTYPE =='C'"> {{item.DATE_TIME_DAT_OD_TIM_P }} - {{item.SUM}} - {{ item.OSND }}</span>
        </li>
      </ul>

    </div>
  </div>
</template>

<script>


export default {
  name: "Home",
  data: function() {
    return {
      privatData: "",
      passw: "",
      startDate:"",
      endDate:""
    }
  },
  methods: {
    getPrivat() {

        if (this.passw == "privatskolkosegodnia"){
        const URL = "https://api.moskitos.com.ua/api/privat"
        this.$http({
          method: "get",
          url: URL,
          
        })
          .then(response => {
            // window.location.href = '/zamovlennia/'+response.data.shat
            // this.$router.push("/zamovlennia/" + response.data.shat);
           
            console.log("response", response);
            //window.location.href = '/zamovlennia/'+response.data.shat
                console.log(response.data);
                console.log(response.status);
                console.log(response.statusText);
                console.log(response.headers);
                console.log(response.config);
            
            this.privatData = response.data.transactions;

            

            //console.log("test answer = ", response);
          })
          .catch(e => {
            console.log(e);
          });

        }
        
    },
getPrivatData() {

        console.log(this.startDate)

        if (this.passw == "privatskolkosegodnia"){
        const URL = "https://api.moskitos.com.ua/api/privatdata"
        this.$http({
          method: "post",
          url: URL,
          data:{
            startDate:this.startDate,
            endDate:this.endDate
          }
          
        })
          .then(response => {
            // window.location.href = '/zamovlennia/'+response.data.shat
            // this.$router.push("/zamovlennia/" + response.data.shat);
           
            console.log("response", response);
            //window.location.href = '/zamovlennia/'+response.data.shat
                console.log(response.data);
                console.log(response.status);
                console.log(response.statusText);
                console.log(response.headers);
                console.log(response.config);
            
            this.privatData = response.data.transactions;

            

            //console.log("test answer = ", response);
          })
          .catch(e => {
            console.log(e);
          });

        }
        
    },    
  }
};
</script>
